<template>
	<div id="app">
		<router-view v-if="isRouterAlive"></router-view>
	</div>
</template>
<script>
	import setting from './api/apiSetting';
	import apiList from './api/apiList.js'
	import apiGroupRole from './api/apiGroupRole.js';
	import apiAllSystem from './api/apiAllSystem.js';
	import Tools from './components/common/Tools.js'
	const serverSrc = setting.geturl();


	export default {
		serverSrc, //服务器API地址
		loginInfo: {}, //登录信息
		name: 'App',

		data() {
			return {
				isRouterAlive: true,

			}
		},
		created() {			


		},
		methods: {

		
		}
	}
</script>
<style>
	@import "./assets/css/main.css";
	@import "./assets/css/color-dark.css";
	/*深色主题*/
	@import "./assets/css/view.css";
	@import "./assets/css/bx-style.css";
	/* 浅绿色主题 */
	/*@import "./assets/css/theme-green/color-green.css";*/


</style>
